import room1 from './images/pexels-pixabay-262047.jpg';
import room2 from './images/pexels-quang-nguyen-vinh-6129982.jpg';
import room3 from './images/pexels-pixabay-164595 (1).jpg';
import room4 from './images/pexels-freemockupsorg-775219.jpg';
import room5 from './images/pexels-pixabay-279746.jpg';
import room6 from './images/pexels-markus-spiske-26139.jpg';
import room7 from './images/pexels-digital-buggu-172872.jpg';


const mockData = [
	{
		src: room1,
		title: "Cocktail bar",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit.",
	},
	{
		src: room2,
		title: "Outdoor pool",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit. Est delectus odit rminus",
	},
	{
		src: room3,
		title: "Our Corner Suite",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit. Est delectus odit reprehenderit molestias",
		cat: "room",
		price: 30,
		stock: 4,
		notAvailablestart: new Date(2022, 4, 26).getTime(),
		notAvailableend: new Date(2022, 4, 30).getTime(),
	},
	{
		src: room4,
		title: "Rooms with balcony",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit. Est delectus odit reprehenderit molestiae ",
		cat: "room",
		price: 380,
		stock: 4,
		notAvailablestart: new Date(2022, 4, 26).getTime(),
		notAvailableend: new Date(2022, 5, 1).getTime(),
	},
	{
		src: room5,
		title: "Junior Suite with kitchenett",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit. Est delectus odit reprehenderit molestiae assumenda, sint minus",
		cat: "room",
		price: 50,
		stock: 4,
		notAvailablestart: new Date(2022, 4, 26).getTime(),
		notAvailableend: new Date(2022, 4, 26).getTime(),
	},
	{
		src: room6,
		title: "Executive room",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing, elit.",
		cat: "room",
		price: 250,
		stock: 4,
		notAvailablestart: new Date(2022, 4, 26).getTime(),
		notAvailableend: new Date(2022, 4, 26).getTime(),
	},
	{
		src: room7,
		title: "Standard Room",
		description:
			"Est delectus odit reprehenderit molestiae assumenda, sint minus",
		cat: "room",
		price: 150,
		stock: 12,
		notAvailablestart: new Date(2022, 4, 26).getTime(),
		notAvailableend: new Date(2022, 4, 26).getTime(),
	},
];

export const chips = [
	{ key: 0, label: "Cancellation Flexibility" },
	{ key: 1, label: "Standard rooms" },
	{ key: 2, label: "Executive rooms" },
	{ key: 3, label: "Access to lounge" },
	{ key: 4, label: "More filters" },
];
export default mockData;